module.exports = __webpack_public_path__ + "img/icon_design.122ff033.png";